import styled, { css } from 'styled-components';

export const InhouseJackpotButtonButtonWrapper = styled.div`
	height: ${props => {
		if (props.isDesktop) {
			return '36px';
		}

		return '28px';
	}};
	width: ${props => props.orientation === 'landscape' && '28px'};
	padding: 2px;
	border-radius: 36px;
	background-color: var(
		${props => {
			if (props.isDesktop) {
				return '--lobby-header-surface-1';
			}

			return props.isOptedin ? '--lobby-header-surface-primary' : '--lobby-header-surface-2';
		}}
	);

	border: ${props => {
		if (props.isDesktop) {
			return 'none';
		}
		return `2px solid var(--lobby-header-surface-1)`;
	}};
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	cursor: pointer;
	${props =>
		props.isDesktop &&
		css`
			margin-right: 12px;
		`}
`;

export const InhouseJackpotText = styled.span`
	font: var(--caption-bold);
	color: var(
		${props => {
			if (props.isDesktop) {
				return '--lobby-header-on-surface';
			}

			return props.isOptedin ? '--lobby-header-on-surface-primary' : '--lobby-header-on-surface';
		}}
	);
	margin-left: ${props => (props.isDesktop ? '10px' : '6px')};
	margin-right: ${props => (props.isDesktop ? '8px' : '4px')};
	${props =>
		props.isDesktop &&
		css`
			font: var(--h4-bold);
		`}
	${props =>
		props.orientation === 'landscape' &&
		css`
			display: none;
		`}
`;

export const InhouseJackpotIconContainer = styled.div`
	width: 24px;
	height: 24px;
	color: var(${props => (props.isOptedin ? '--lobby-header-on-surface-primary' : '--lobby-header-on-surface')});
	background-color: var(
		${props => (props.isOptedin ? '--lobby-header-surface-primary' : '--lobby-header-surface-2')}
	);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		fill: currentColor;
	}
	position: relative;

	${props =>
		props.isDesktop &&
		css`
			border-radius: 50%;
			width: 32px;
			height: 32px;
		`}

	${props =>
		props.inhouseJackpotIconUrl &&
		css`
			&::after {
				background-color: currentColor;
				content: '';
				position: absolute;
				left: 6px;
				right: 6px;
				top: 6px;
				bottom: 6px;
				background-size: cover;
				mask: url(${props.inhouseJackpotIconUrl}) no-repeat 50% 50%;
			}
		`}
`;
